import React from 'react';
import {
    Box,
} from '@mui/material';
import PageLoader from '../../../components/pageloader/pageLoader';

const ProcedureTables = ({procedures, lob}) => {
    const categorizedProcedures = procedures.reduce((acc, lob) => {
      lob.procedures.forEach(proc => {

        const typeKey = (proc.type === 'CPTPLA') ? 'CPT' : proc.type; // 🟢 Combine CPTPLA into CPT
        
        if (!acc[typeKey]) acc[typeKey] = [];
        acc[typeKey].push({ ...proc, lob_title: lob.lob_title });
      });
      return acc;
    }, {});
  
    return (
      <div className="p-4 space-y-8">
        {Object.entries(categorizedProcedures).map(([type, items]) => (
          <div key={type} className="border rounded-xl shadow p-4">
            <h4 className="text-xl font-semibold mb-4">{type.toUpperCase()==='HCPC' ? 'HCPCS' : type}:</h4>
            <table className="w-full table-auto border-collapse tblProcedureCodes" width="98%">
              {false && (<thead>
                <tr className="bg-gray-200">
                  <th className="border px-4 py-2 text-left"><strong>Code</strong></th>
                  <th className="border px-4 py-2 text-left"><strong>Description</strong></th>
                  {!(lob && lob?.length>0) && (<th className="border px-4 py-2 text-left"><strong>Line of Business</strong></th>)}
                </tr>
              </thead>)}
              <tbody>
                {items.map((proc, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td width="150" className="border px-4 py-2">{proc.code}</td>
                    <td className="border px-4 py-2">{proc.title}</td>
                    {!(lob && lob?.length>0) && (<td width="250" className="border px-4 py-2">{proc.lob_title}</td>)}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    );
};

const ProcedureCodes = ({policyData, lob}) => {

    const [procedureCodes, setProcedureCodes] = React.useState([]);
    const [openLoader, setOpenLoader] = React.useState(false);

    function getFilteredProcedureCodes(lobParam, procedureCodes) {
    
        // If lob is provided, split and trim to get list of lob titles
        const lobs = lobParam
            ? lobParam.split(",").map(lob => decodeURIComponent(lob.trim().toLowerCase()))
            : null;
    
        // Filter procedureCodes based on presence or absence of lob
        const filtered = procedureCodes.filter(item => {
            if (!lobs) return true; // If no lob filter is provided, return all
            return lobs.includes(item?.lob_title?.toLowerCase());
        });
    
        return filtered;
    }

    
    
    React.useEffect(() => {
        setOpenLoader(true);

        if (policyData?.procedures && policyData?.procedures?.length>0) {

            const filteredPC = getFilteredProcedureCodes(lob, policyData?.procedures);

            setProcedureCodes(filteredPC);
            
        }

        setOpenLoader(false);

    }, [lob, policyData?.procedures]);

    return (
        <Box>
            {procedureCodes && procedureCodes?.length>0 && (<><h3 className="sectionHeading" style={{textTransform: 'uppercase'}}>CURRENT CODING</h3>
            <div className="preview-header-section">
                <PageLoader openLoader={openLoader} />
                {procedureCodes.length===0 ? <p>No Data</p> : 
                    (<ProcedureTables procedures={procedureCodes} lob={lob} />)
                }
            </div></>)}
        </Box>
    )

}

export default ProcedureCodes;